import type { TithelyNavSettingsSection, TithelyNavSettingsItem } from '@/types/nav/tithelyNav'
import {
    PhBell,
    PhChecks,
    PhClockCounterClockwise,
    PhCreditCard,
    PhGear,
    PhGitFork,
    PhHouse,
    PhLink,
    PhMusicNotesPlus,
    PhPuzzlePiece,
    PhRobot,
    PhUser,
    PhUserList,
    PhUsers
} from '@phosphor-icons/vue'
import { Permission } from '@/services/api/client'

const TRINITY_NAV_SETTINGS: Record<TithelyNavSettingsSection, TithelyNavSettingsItem[]> = {
    church: [
        {
            label: `roles`,
            icon: PhUsers,
            route: `/roles/all`,
            roles: [Permission.USERS]
        },
        {
            label: `profile_mapping`,
            icon: PhLink,
            route: `/admin/users`,
            roles: [Permission.USERS]
        },
        {
            label: `automations`,
            icon: PhRobot,
            route: `/bulk/automated_tasks`,
            roles: [Permission.AUTOMATIONS]
        },
        {
            label: `profile_fields`,
            icon: PhChecks,
            route: `/admin/profile`,
            roles: [Permission.PROFILE]
        },
        {
            label: `history`,
            icon: PhClockCounterClockwise,
            route: `/history`,
            roles: [Permission.HISTORY]
        },
        {
            label: `logs`,
            icon: PhGear,
            route: '/account/log',
            roles: [Permission.ACCOUNT_LOG]
        },
        {
            label: `extensions`,
            icon: PhPuzzlePiece,
            route: `/extensions`,
            roles: [Permission.MARKETPLACE]
        },
        {
            label: `song_library`,
            icon: PhMusicNotesPlus,
            route: `/songs`,
            features: [`song-library`, `service_plan_integration`],
            roles: [Permission.EVENTS_MODIFY]
        },
        {
            label: `song_library`,
            icon: PhMusicNotesPlus,
            route: `/account/tithely/sso?redirect=/offer/service_planning`,
            features: [`song-library`, `!service_plan_integration`],
            isTithelyGivingEnabled: true,
            roles: [Permission.EVENTS_MODIFY],
            tag: `upgrade`,
            badge: `upgrade`
        },
        {
            label: `song_library`,
            icon: PhMusicNotesPlus,
            route: `/extensions?name=service_plan_integration`,
            features: [`song-library`, `!service_plan_integration`],
            isTithelyGivingEnabled: false,
            roles: [Permission.EVENTS_MODIFY],
            tag: `upgrade`,
            badge: `upgrade`
        }
    ],
    userAndOrganization: [
        {
            label: `my_organization`,
            icon: PhHouse,
            sso: `/admin/organization`,
            roles: [`tithely:administrator`, `primary`],
            orRoles: true
        },
        {
            label: `bulk`,
            icon: PhUserList,
            route: `/bulk/merge_people`,
            roles: [Permission.BULK]
        },
        {
            label: `billing`,
            icon: PhCreditCard,
            sso: `/billing/invoices`,
            roles: [`tithely:administrator`, `primary`],
            orRoles: true
        },
        {
            label: `giving_integrations`,
            icon: PhGitFork,
            sso: `/integrations/official`,
            roles: [`tithely:administrator`, `tithely:administration:integrations`, `primary`],
            orRoles: true
        }
    ],
    account: [
        {
            label: `user_settings`,
            icon: PhUser,
            sso: `/account/core-info`
        },
        {
            label: `notifications`,
            icon: PhBell,
            sso: `/account/notifications`
        }
    ]
}

export default TRINITY_NAV_SETTINGS
